import React, { useState } from 'react';
import { Info, X } from 'lucide-react';
import '../styles/tooltip.css';

interface TooltipProps {
  content: string | React.ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

export default function Tooltip({ content, position = 'bottom' }: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="tooltip-container">
      <span
        className="info-icon"
        onClick={() => setIsVisible(!isVisible)}
      >
        <Info size={16} />
      </span>
      {isVisible && (
        <div className={`tooltip-popup tooltip-${position}`}>
          {content}
          <button 
            className="tooltip-close"
            onClick={(e) => {
              e.stopPropagation();
              setIsVisible(false);
            }}
          >
            <X size={14} />
          </button>
        </div>
      )}
    </div>
  );
}

